import { Share2, MessageCircle, Facebook, Twitter, Send, Link2, Check } from "lucide-react";
import { useState } from "react";
import { toast } from "sonner";
import { Button } from "@/components/ui/button";
import { DropdownMenu, DropdownMenuTrigger, DropdownMenuContent, DropdownMenuItem } from "@/components/ui/dropdown-menu";

export default function SocialShare({ url, text, label = "Share", size = "sm", testid = "social-share" }) {
  const [copied, setCopied] = useState(false);
  const shareUrl = url || (typeof window !== "undefined" ? window.location.href : "");
  const enc = encodeURIComponent;
  const platforms = [
    { name: "WhatsApp", icon: MessageCircle, href: `https://wa.me/?text=${enc(text + " " + shareUrl)}`, color: "text-emerald-400" },
    { name: "Facebook", icon: Facebook, href: `https://www.facebook.com/sharer/sharer.php?u=${enc(shareUrl)}`, color: "text-blue-500" },
    { name: "X (Twitter)", icon: Twitter, href: `https://twitter.com/intent/tweet?text=${enc(text)}&url=${enc(shareUrl)}`, color: "text-zinc-200" },
    { name: "Telegram", icon: Send, href: `https://t.me/share/url?url=${enc(shareUrl)}&text=${enc(text)}`, color: "text-sky-400" },
  ];

  const copy = async () => {
    try {
      await navigator.clipboard.writeText(shareUrl);
    } catch {
      const ta = document.createElement("textarea");
      ta.value = shareUrl; ta.style.position = "fixed"; ta.style.opacity = "0";
      document.body.appendChild(ta); ta.select();
      try { document.execCommand("copy"); } catch { /* noop */ }
      document.body.removeChild(ta);
    }
    setCopied(true);
    toast.success("Link copied");
    setTimeout(() => setCopied(false), 2000);
  };

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button variant="outline" size={size} className="border-white/15 bg-transparent rounded-full" data-testid={`${testid}-trigger`}>
          <Share2 className="w-4 h-4 mr-2" /> {label}
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end" className="bg-[#131519] border-white/10 text-white">
        {platforms.map((p) => (
          <DropdownMenuItem key={p.name} asChild className="cursor-pointer focus:bg-white/10">
            <a href={p.href} target="_blank" rel="noreferrer" data-testid={`${testid}-${p.name.split(" ")[0].toLowerCase()}`}>
              <p.icon className={`w-4 h-4 mr-2 ${p.color}`} /> {p.name}
            </a>
          </DropdownMenuItem>
        ))}
        <DropdownMenuItem onClick={copy} className="cursor-pointer focus:bg-white/10" data-testid={`${testid}-copy`}>
          {copied ? <Check className="w-4 h-4 mr-2 text-emerald-400" /> : <Link2 className="w-4 h-4 mr-2" />} Copy link
        </DropdownMenuItem>
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
